import { Injectable, NgZone } from '@angular/core';
import { HttpHelper } from './http.service';
import { AppConfig } from '../model/config';
import { Message } from '../model/message';
import { List } from 'immutable';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs-compat';
import { ToastrService } from 'ngx-toastr';
import { SignalRService } from './signalr.service';

@Injectable()
export class MessageService {

  private readonly messages: BehaviorSubject<List<Message>> = new BehaviorSubject(List([]));
  public readonly Messages: Observable<List<Message>> = this.messages.asObservable();

  private readonly unreadCount: BehaviorSubject<number> = new BehaviorSubject(0);
  public readonly UnreadCount: Observable<number> = this.unreadCount.asObservable();

  private readonly backendUrl: string;

  constructor(
    private readonly configuration: AppConfig,
    private readonly http: HttpHelper,
    private readonly toastr: ToastrService,
    private readonly zone: NgZone,
    private readonly signalRService: SignalRService) {

    this.backendUrl = this.configuration.backendUrl;

    this.signalRService.deleteMessage$.subscribe((message: Message) => { this.onDeleteMessage(message); });
    this.signalRService.updateMessage$.subscribe((message: Message) => { this.onUpdateMessage(message); });

  }

  public async loadMessages() {
    // messages
    await this.http.get(this.backendUrl + "/api/message/all", (data: Message[]) => {

      let dataMessages = Message.ToTypeSafeList(data);

      let messages = List<Message>();
      dataMessages.forEach((message) => {
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        if (message.updatedAt >= yesterday) {
          messages = messages.push(message);
        }
      });
      this.zone.run(() => this.messages.next(messages));
      let unreadCount = messages.countBy(m => m.isRead).toJS().false;
      if (unreadCount > 0) {
        this.unreadCount.next(unreadCount);
      }

      if (dataMessages.length == 0) {
        this.zone.run(() => this.messages.next(List([])));
      }

    }, (error) => { }).toPromise<any>();
  }

  public async updateMessage(message: Message): Promise<any> {

    return this.http.post(this.configuration.backendUrl + "/api/message/addOrUpdate", message,
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  private onUpdateMessage(message: Message) {
    console.log("updateMessage");
    let messages = this.messages.getValue();
    let index = messages.findIndex((m: Message) => m.id === message.id);
    this.messages.next(messages.set(index, message));  //can we get away without a new?
    if (message.response && message.type === '2') {
      this.toastr.info(`Från ${message.senderName} \n${message.response}`, 'Svar');
    }
    let unreadCount = this.messages.getValue().countBy(m => m.isRead).toJS().false;
    this.zone.run(() => this.unreadCount.next(unreadCount));

  }

  private onDeleteMessage(message: Message) {
    console.log("deleteMessage");
    this.zone.run(() => {
      let messages: List<Message> = this.messages.getValue();
      let index = messages.findIndex(m => m.id === message.id);

      if (index - 1) {
        this.onCreateMessage(message);
        return;
      }

      this.messages.next(messages.delete(index));
      let unreadCount = messages.countBy(m => m.isRead).toJS().false;
      this.unreadCount.next(unreadCount);
    });

  }

  private onCreateMessage(message: Message) {
    console.log("createMessage", message);
    this.messages.next(this.messages.getValue().push(message));
    //Is it a new message from mobileapp?
    if (message.recipientID === null) {
      this.toastr.info(`Från ${message.senderName} \n${message.title}`, 'Nytt meddelande');
    }
    let unreadCount = this.messages.getValue().countBy(m => m.isRead).toJS().false;
    this.zone.run(() => this.unreadCount.next(unreadCount));

  }
}
